import { create } from 'zustand'
import type { OrientationRequest, OrientationResult, OrientationConfirmResult } from '@/lib/orientationApi'

export type OrientationStep = 1 | 2 | 3

interface OrientationState {
  step: OrientationStep
  formData: OrientationRequest | null
  result: OrientationResult | null
  confirmResult: OrientationConfirmResult | null
  isLoading: boolean
  error: string | null

  // Actions
  setStep: (step: OrientationStep) => void
  setFormData: (data: OrientationRequest) => void
  setResult: (result: OrientationResult) => void
  setConfirmResult: (result: OrientationConfirmResult) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  reset: () => void
}

export const useOrientationStore = create<OrientationState>((set) => ({
  step: 1,
  formData: null,
  result: null,
  confirmResult: null,
  isLoading: false,
  error: null,

  setStep: (step) => set({ step }),
  setFormData: (data) => set({ formData: data }),
  setResult: (result) => set({ result, step: 2 }),
  setConfirmResult: (result) => set({ confirmResult: result, step: 3 }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  reset: () => set({ step: 1, formData: null, result: null, confirmResult: null, isLoading: false, error: null }),
}))
